import { inject, Injector } from '@angular/core';
import { AbstractAnnotationStore } from '../../../../outputs/annotation/annotation-shared/state/root/abstract-annotation-store';
import { PointType } from '../../../../team-apis/otterdam/answers/shape-typings';
import {
  ClientFeedback,
  ShapeFeedback,
} from '../../../../team-apis/otterdam/feedback';
import { outputInfoStoreToken } from '../../../h3ml/state/output-info';
import { FusionManager } from '../../../outputs/annotation/annotation-shared/fusion/fusion-manager';
import { contentConnectorToken } from '../../../outputs/annotation/utils/misc-utils';

export abstract class AbstractFeedbackCrudService<
  T extends ShapeFeedback | ClientFeedback,
> {
  protected outputInfoStore = inject(outputInfoStoreToken);
  protected store = inject(AbstractAnnotationStore);
  protected fusionManager = inject(FusionManager);

  private injector = inject(Injector);

  setFeedbackCoordinates(
    coordinates: PointType,
    isDialogOpen: boolean,
    feedback?: T,
  ) {
    const outputId = feedback ? this.getFeedbackOutputId(feedback) : undefined;
    if (outputId === this.outputInfoStore.state().output.id || isDialogOpen) {
      this.getContentConnector().setFeedbackMarkers([coordinates]);
    }
  }

  protected getContentConnector() {
    // to avoid circular injection issue
    return this.injector.get(contentConnectorToken);
  }

  abstract getFeedbackCoordinates(feedback: T): PointType | undefined;

  abstract delete(feedbackId: string): void;

  abstract getFeedback(selectedFeedbackId: string): T | undefined;

  abstract getFeedbackOutputId(feedback: T): number;
}
